import { render, staticRenderFns } from "./LimitTypeFileUpload.vue?vue&type=template&id=6e56feb6&scoped=true&"
import script from "./LimitTypeFileUpload.vue?vue&type=script&lang=js&"
export * from "./LimitTypeFileUpload.vue?vue&type=script&lang=js&"
import style0 from "./LimitTypeFileUpload.vue?vue&type=style&index=0&id=6e56feb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e56feb6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VCardText,VTab,VTabItem,VTabs,VTabsItems})
